/**
 * Row data: the app events of the SSE stream with the package that emits each and the gate it
 * falls due at (1.0b deliverable 14). `registryRows()` reads them as the `sse:` rows, none draft;
 * the AI run events stay draft rows of 3.0. A row with `stage` is implemented by that stage of
 * its staged owner (`clock.changed`: 1.L-2, stage 2), which the due-row audit reads. Pure data (excluded from mutation testing).
 */
export const APP_EVENT_ROWS = [
    { type: 'sys.heartbeat', owner: '1.1', since: 'editor-alpha' },
    { type: 'sys.release', owner: '1.1', since: 'editor-alpha' },
    { type: 'doc.changed', owner: '1.A', since: 'editor-alpha' },
    { type: 'doc.lifecycle', owner: '1.A', since: 'exit-1a' },
    { type: 'links.changed', owner: '1.C', since: 'exit-1a' },
    { type: 'types.changed', owner: '1.B-1', since: 'exit-1a' },
    { type: 'asset.ready', owner: '1.R', since: 'editor-alpha' },
    { type: 'export.ready', owner: '1.P', since: 'exit-1a' },
    { type: 'inbox.counts', owner: '1.N-3', since: 'exit-1b' },
    { type: 'chrono.changed', owner: '1.L-2', since: 'exit-1b' },
    { type: 'clock.changed', owner: '1.L-2', since: 'exit-1b', stage: '2' },
    { type: 'ledger.changed', owner: '1.M-1', since: 'exit-1b' },
    // CS r4a: the import's progress, emitted by 2.B-1's jobs from its stage s1.
    { type: 'import.progress', owner: '2.B-1', since: 'exit-2a', stage: 's1' },
    // CS r5a: a session's parts changed, emitted by 2.C's session writes from its stage s1.
    { type: 'session.changed', owner: '2.C', since: 'exit-2b', stage: 's1' },
];
//# sourceMappingURL=rows-app-events.js.map